<template>
  <qd-loader :active="chargement">
    <div class="is-multiline">
      <div class="title is-size-3 column columns is-flex
     is-narrow is-justify-content-space-between pdb-0 is-cursor-pointer"
           @click="open = !open">
        <div class="column is-narrow columns mgv-0 pd-0">
        <p
          class="column is-narrow is-size-5">
          {{ title + " (" + messages.length + ")" }}
        </p>
        </div>
        <div class="level-right">
          <b-tooltip
            class="level-right"
            position="is-left"
            :label="open
          ? $t('gestionMessage.actions.masquer') : $t('gestionMessage.actions.afficher')">
        <span
          class="is-cursor-pointer">
          <b-icon
            :icon="open ? 'chevron-down' : 'chevron-right'"
            type="is-default"/>
        </span>
          </b-tooltip>
        </div>
      </div>
      <qd-collapse :open="open">
        <div class="columns pd-3">
          <div class="column is-narrow">
            <avatar
              :username="getUserName"
              :size="33"
              :src="logo"/>
          </div>
          <div class="column">
            <qd-loader
              :active="isLoading">
              <b-input
                class="no-resize pd-0 pdr-3"
                v-model="newMsg"
                type="textarea"
                :placeholder="$t('gestionMessage.messages.placeholder')"
                @input="checkIsWriting"/>
            </qd-loader>
            <div
              class="mt-3"
              :class="{
                'is-invisible': !isWriting,}">
              <div class="buttons">
                <qd-button type="is-addOrEdit" @click="sauvegarder()">
                  {{ $t('gestionMessage.button.enregistrer') }}
                </qd-button>
                <qd-button @click="annuler()">
                  {{ $t('gestionMessage.button.annuler') }}
                </qd-button>
              </div>
            </div>
          </div>
        </div>
        <div class="overflow-y-scroll overflow-x-hidden max-height-320 pdb-3 mgl-2">
          <div v-for="message in messages"
               class="mgb-3"
               :key="message.id">
            <messageContainer
              class="is-12"
              v-if="message.creatorName"
              :message="message"
              :reload="getMessages"
              @deleteMessage="deleteMessage"/>
          </div>
        </div>
      </qd-collapse>
    </div>
  </qd-loader>
</template>

<script>
import { getAll, create } from '@/api/gestionMessage';
import messageContainer from '@/components/commun/gestionMessage/messageContainer';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import Avatar from 'vue-avatar';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { createNamespacedHelpers } from 'vuex';
import getLogo from '@/services/general/getLogo';
import intToGuid from '@/services/general/transformIntToGuid';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import getPiecesJointeLogoByIds from '@/services/piecesJointes/getPiecesJointeLogoByIds';

const user = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'gestionMessage',
  props: {
    title: {
      type: String,
      required: true,
    },
    elementId: {
      type: String,
      required: true,
    },
    module: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      open: false,
      isWriting: false,
      newMsg: '',
      logo: null,
      isLoading: false,
      chargement: true,
      allUser: [],
    };
  },
  components: {
    messageContainer,
    Avatar,
  },
  computed: {
    ...user.mapGetters({
      utilisateur: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    getUserName() {
      return nomPrenomGetter(this.utilisateur);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    distinct(value, index, self) {
      return self.indexOf(value) === index;
    },
    async getMessages() {
      const data = {
        query: {
          elementId: this.elementId,
          moduleType: this.module,
        },
      };
      this.messages = (await getAll(data)).data.result.items;
      const messageUserGuid = [];
      const messagesUserIds = this.messages.map(
        (message) => message.creatorUserId).filter(this.distinct);

      messagesUserIds.forEach((message, index) => {
        messageUserGuid[index] = { id: intToGuid(message) };
      });
      await getPiecesJointeLogoByIds(messageUserGuid);

      this.allUser = await this.parametre(PARAMETRES_KEYS.utilisateur);
      this.allUser = this.allUser.filter((user) => messagesUserIds.includes(user.id));
      this.allUser.forEach((user) => {
        user.logo = messageUserGuid.find((message) => intToGuid(user.id) === message.id)?.cheminMin;
      });

      this.messages.forEach((message) => {
        const user = this.allUser.find((user) => user.id === message.creatorUserId);
        const nom = user.nom ? user.nom + ' ' : '';
        const prenom = user.prenom ? user.prenom : '';

        message.creatorName = nom + prenom;
        message.userLogo = user.logo;
      });
    },
    deleteMessage(message) {
      this.messages = this.messages
        .filter((msg) => msg.id !== message.id);
      this.$emit('updateCount', this.messages?.length ?? 0);
    },
    checkIsWriting() {
      this.isWriting = this.newMsg.trim().length > 0;
    },
    annuler() {
      this.newMsg = '';
      this.checkIsWriting();
    },
    async sauvegarder() {
      this.isLoading = true;
      try {
        this.newMsg = this.newMsg.replaceAll('\n', '<br>');
        const message = (await create(this.elementId, this.module, this.newMsg)).data.result;
        if (this.newMsg === message.message) {
          this.messages.unshift(message);
          this.newMsg = '';
          this.checkIsWriting();
          messageSucces(this.$t('gestionMessage.messages.succesSave'));
          await this.getMessages();
          this.$emit('updateCount', this.messages?.length ?? 0);
        } else {
          this.newMsg = this.newMsg.replaceAll('<br>', '\n');
          messageErreur(this.$i18n);
        }
        this.isLoading = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    this.chargement = true;
    try {
      await this.loadParametreUtilisateur();
      this.logo = await getLogo(intToGuid(this.utilisateur.id));
      await this.getMessages();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      this.chargement = false;
    }
  },
};
</script>
